/**
 * Gate for the no-auth /demo/* routes (mock-data app shell used for screenshots,
 * videos, and the @smoke Playwright specs).
 *
 * Enabled in:
 * - 'development' — local dev servers and the deployed dev project
 * - 'test' — the CI smoke job (ci.yml e2e-smoke), which builds with
 *   VITE_APP_ENV=test; its demo-route specs (e2e/smoke/*-visual.spec.ts)
 *   need /demo to render instead of redirecting to /
 *
 * Deployed builds get VITE_APP_ENV from repo vars ('development'/'production'),
 * so 'test' only ever exists in CI — demo stays unreachable in production.
 */
export const isDemoRouteEnabled = (appEnv: string | undefined): boolean =>
  appEnv === 'development' || appEnv === 'test';
